import { Link } from "@tanstack/react-router";
import { Section } from "@/components/Section";
import { useHomepageContent } from "@/hooks/useHomepageContent";
import { HOMEPAGE_FALLBACKS } from "@/lib/homepage-defaults";

export function FounderPreview() {
  const content = useHomepageContent();
  const isDefaultImage = content.founderImageUrl === HOMEPAGE_FALLBACKS.founderImageUrl;
  return (
    <Section>
      <div className="grid gap-12 md:grid-cols-[1.1fr_1fr] md:items-center md:gap-16 lg:gap-24">
        <div className="relative">
          <div
            aria-hidden
            className="absolute -bottom-4 -left-4 hidden h-full w-full rounded-3xl bg-accent/15 md:block"
          />
          <div className="relative overflow-hidden rounded-3xl ring-1 ring-border">
            <img
              src={content.founderImageUrl}
              alt={isDefaultImage ? "[DEMO] Professional portrait of the founder in a modern kitchen (demonstration image)." : "Portrait of the founder"}
              loading="lazy"
              width={900}
              height={1100}
              className="aspect-[4/5] h-full w-full object-cover"
            />
            {isDefaultImage ? (<span className="absolute bottom-4 left-4 rounded-full bg-background/90 px-3 py-1 text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
              Demo Founder Image
            </span>) : null}
          </div>
        </div>

        <div>
          <div className="mb-3 h-px w-10 bg-primary/40" aria-hidden />
          <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Founder</span>
          <h2 className="mt-3 font-display text-4xl font-medium md:text-5xl">{content.founderHeading}</h2>
          <p className="mt-6 text-base leading-relaxed text-muted-foreground">
            {content.founderDescription}
          </p>

          <div className="mt-10 grid gap-8 sm:grid-cols-2 sm:divide-x sm:divide-border">
            <div className="sm:pr-6">
              <div className="text-xs uppercase tracking-[0.2em] text-primary">Mission</div>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                Curate healthy, tasty, non-repetitive combos that help people achieve their health goals.
              </p>
            </div>
            <div className="sm:pl-6">
              <div className="text-xs uppercase tracking-[0.2em] text-primary">Vision</div>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                A global community uniting farmers, women and the LGBTQIA+ community.
              </p>
            </div>
          </div>

          <Link
            to="/about"
            className="mt-10 inline-flex items-center rounded-full border border-border bg-background px-6 py-3 text-sm font-medium text-foreground transition-colors hover:bg-secondary"
          >
            Read More
          </Link>
        </div>
      </div>
    </Section>
  );
}